import { makeStyles } from '@material-ui/core';

export const useViewTournamentDetailsStyle = makeStyles(theme => ({
  itemContainer: {
    marginBottom: 15,
    marginTop: 25,
    margin: 'auto',
  },
  tournamentName: {
    marginTop: theme.spacing(1),
    fontWeight: 'bold',
  },
  pageTitleGrid: {
    fontWeight: 'bold',
    textAlign: 'center',
    padding: theme.spacing(1),
  },
  textField: {
    width: '75%',
  },
  label: {
    textAlign: 'start',
    paddingLeft: theme.spacing(5),
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}));

export const useEditTournamentStyles = makeStyles(theme => ({
  datePicker: { margin: 0, padding: 0 },
}));
